/** Render the /api/health probe result for the skeleton page (and its tests). */
export function formatApiStatus(httpStatus: number, body: unknown): string {
  if (httpStatus === 0) return 'unreachable';
  if (httpStatus !== 200) return `error (HTTP ${httpStatus})`;
  const status =
    typeof body === 'object' && body !== null && 'status' in body
      ? String((body as { status: unknown }).status)
      : 'unknown';
  return status === 'ok' ? 'ok' : `unexpected (${status})`;
}
